import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { X } from 'phosphor-react'

import './Header.scss'

import BrandLogo from '../../img/brand-logo2.png'

function MobileNavDrawer({ isOpen, onClose }) {
    useEffect(() => {
        if (!isOpen) return undefined
        const prev = document.body.style.overflow
        document.body.style.overflow = 'hidden'
        return () => {
            document.body.style.overflow = prev
        }
    }, [isOpen])

    useEffect(() => {
        if (!isOpen) return undefined
        const onKey = (e) => {
            if (e.key === 'Escape') onClose()
        }
        window.addEventListener('keydown', onKey)
        return () => window.removeEventListener('keydown', onKey)
    }, [isOpen, onClose])

    return (
        <div
            className={`mobile_nav_drawer ${isOpen ? 'is-open' : ''}`}
            aria-hidden={!isOpen}
        >
            <button
                type="button"
                className="mobile_nav_drawer__backdrop"
                aria-label="Close menu"
                onClick={onClose}
            />
            <div
                className="mobile_nav_drawer__panel"
                role="dialog"
                aria-modal="true"
                aria-label="Navigation"
            >
                <div className="mobile_nav_drawer__head">
                    <Link className="mobile_nav_drawer__logo_otr" to="/" onClick={onClose}>
                        <img className="mobile_nav_drawer__logo" src={BrandLogo} alt="Foodies home" />
                    </Link>
                    <button
                        type="button"
                        className="mobile_nav_drawer__close"
                        aria-label="Close menu"
                        onClick={onClose}
                    >
                        <X size={22} />
                    </button>
                </div>
                <nav className="mobile_nav_drawer__nav">
                    <Link className="mobile_nav_drawer__link heading-sb" to="/about" onClick={onClose}>
                        About us
                    </Link>
                    <Link className="mobile_nav_drawer__link heading-sb" to="/contact" onClick={onClose}>
                        Contact us
                    </Link>
                    <Link className="mobile_nav_drawer__link heading-sb" to="/login" onClick={onClose}>
                        Account
                    </Link>
                    <Link className="mobile_nav_drawer__link heading-sb" to="/" onClick={onClose}>
                        Home
                    </Link>
                    <Link className="mobile_nav_drawer__link heading-sb" to="/shop" onClick={onClose}>
                        Shop
                    </Link>
                    <Link className="mobile_nav_drawer__link heading-sb" to="/cart" onClick={onClose}>
                        Cart
                    </Link>
                    <Link className="mobile_nav_drawer__link heading-sb" to="/empty_cart" onClick={onClose}>
                        Cart Empty
                    </Link>
                    <Link className="mobile_nav_drawer__link heading-sb" to="/wishlist" onClick={onClose}>
                        Wishlist
                    </Link>
                    <Link className="mobile_nav_drawer__link heading-sb" to="/empty_wishlist" onClick={onClose}>
                        Wishlist Empty
                    </Link>
                    <Link className="mobile_nav_drawer__link heading-sb" to="/checkout" onClick={onClose}>
                        Checkout
                    </Link>
                    <Link className="mobile_nav_drawer__link heading-sb" to="/faq" onClick={onClose}>
                        Faq
                    </Link>
                    <Link className="mobile_nav_drawer__link heading-sb" to="/comming_soon" onClick={onClose}>
                        Comming Soon
                    </Link>
                    <Link className="mobile_nav_drawer__link heading-sb" to="/signup" onClick={onClose}>
                        Sign up
                    </Link>
                    <Link className="mobile_nav_drawer__link heading-sb" to="/404" onClick={onClose}>
                        404
                    </Link>
                    <Link className="mobile_nav_drawer__link heading-sb" to="/blog" onClick={onClose}>
                        Blogs
                    </Link>
                </nav>
            </div>
        </div>
    )
}

export default MobileNavDrawer
